import transport from '../transport';
export default transport;


// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio/es/services/auth/index.js